import * as React from 'react';
import { AppComponentProps } from '../../typescriptHelpers';
import { QualitativeOnboardingTaskList } from '@/components/QualitativeOnboardingTaskList';

export const SetupTasks: React.FC<AppComponentProps> = ({ appId, orgId }) => {
    return <QualitativeOnboardingTaskList orgId={orgId} appId={appId} shouldForceShowOnboarding />;
};
